export enum AssignmentType {
  Assign = 1,
  Unassign
}